import { ContainerModule } from 'inversify';
import { ExamResultService, ExamResultServiceSymbol } from './exam-result-service'
import * as Commands from './commands'

export const examResultServiceModule = new ContainerModule((bind) => {
  bind(ExamResultServiceSymbol).to(ExamResultService).inSingletonScope();
  bind(Commands.FinishExamAttemptCommandHandler).toSelf()
  bind(Commands.QueryExamsTrackingStateCommandHandler).toSelf()
});
